import {MasterState, MastersState} from '@target-web/leadads-form-view';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {fetchComments} from 'utils/requests';
import {useSearchParams} from 'utils/searchParamsContext';

type useMasterProps = {
    staffId: number | null;
    masters: MastersState['masters'];
    active?: boolean;
};

export const useMaster = ({masters, staffId}: useMasterProps): MasterState => {
    const [comments, setComments] = useState<MasterState['comments']>([]);
    const {formDataHash} = useSearchParams();

    const searchParams = useMemo(() => {
        const add_params: Record<string, string> = {lead_form_data: formDataHash};

        if (staffId) {
            add_params.staff_id = staffId.toString();
        }

        add_params.count = '10000';

        return new URLSearchParams([...Object.entries(add_params)]);
    }, [staffId, formDataHash]);

    const getComments = useCallback(async () => {
        if (!staffId) return;
        setComments([]);
        const data = await fetchComments(searchParams.toString());
        setComments(data);
    }, [searchParams, staffId]);

    useEffect(() => {
        getComments();
    }, [getComments]);

    const master = useMemo(() => {
        return masters.find(({id}) => id === staffId);
    }, [masters, staffId]);

    return {
        master,
        comments,
    };
};
